module.exports = __webpack_public_path__ + "static/media/Screenshot_1.fe56b5be.png";